import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.GET_REGULATION_BASE_FINANCE_ATTRIBUTIONS]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/',
	},

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.GET_REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/:financeAttributionId/',
	},

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.CREATE_REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.PATCH_REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.PUT_REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]
		.DELETE_REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
